import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { OnInit, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageHomeComponent implements OnInit {
    public search: string = '';
    public searchType: string = 'keyword';
    public stats: any = { researchers: 0, publications: 0, affiliations: 0 };
    public statCards: any[] = [];
    public activeStatIndex: number = 0;
    public searchTypeDropdownOpen: boolean = false;

    public searchTypes: any[] = [
        { value: 'researcher', label: '연구자' },
        { value: 'keyword', label: '키워드' }
    ];

    public isLoggedIn: boolean = false;
    public userName: string = '';
    public userRole: string = '';
    public showLoginModal: boolean = false;
    public loginId: string = '';
    public loginPw: string = '';
    public loginError: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.checkSession();
        await this.loadStats();
        await this.service.render();
    }

    public async checkSession() {
        try {
            const { code, data } = await wiz.call("check_session");
            if (code === 200 && data.loggedIn) {
                this.isLoggedIn = true;
                this.userName = data.name || data.id;
                this.userRole = data.role || 'user';
            }
        } catch (e) { }
    }

    public async loadStats() {
        const { code, data } = await wiz.call("stats");
        if (code === 200) {
            this.stats = data;
            this.statCards = [
                { label: '연구자', value: data.researchers, icon: 'researcher' },
                { label: '기관', value: data.affiliations, icon: 'affiliation' },
                { label: '성과물', value: data.publications, icon: 'publication' }
            ];
        }
    }

    public toggleStat(index: number) {
        this.activeStatIndex = this.activeStatIndex === index ? -1 : index;
        this.service.render();
    }

    public get searchPlaceholder(): string {
        const placeholders: any = {
            researcher: '연구자 이름을 입력하세요',
            keyword: '연구 키워드를 입력하세요'
        };
        return placeholders[this.searchType] || '키워드를 입력하세요';
    }

    public get selectedSearchType(): any {
        return this.searchTypes.find((type: any) => type.value === this.searchType) || this.searchTypes[0];
    }

    @HostListener('document:click')
    public async onDocumentClick() {
        if (!this.searchTypeDropdownOpen) return;
        this.searchTypeDropdownOpen = false;
        await this.service.render();
    }

    public async toggleSearchTypeDropdown(event: Event) {
        event.stopPropagation();
        this.searchTypeDropdownOpen = !this.searchTypeDropdownOpen;
        await this.service.render();
    }

    public async selectSearchType(value: string, event?: Event) {
        if (event) event.stopPropagation();
        this.searchType = value;
        this.searchTypeDropdownOpen = false;
        await this.service.render();
    }

    public async onSearch() {
        const keyword = this.search.trim();
        if (!keyword) return;

        const params = new URLSearchParams();
        params.set('q', keyword);
        if (this.searchType === 'keyword') params.set('tab', 'keyword');
        this.service.href(`/search?${params.toString()}`);
    }

    public formatNumber(n: number): string {
        if (!n) return '0';
        return n.toLocaleString();
    }

    public openLogin() {
        this.loginId = '';
        this.loginPw = '';
        this.loginError = '';
        this.showLoginModal = true;
        this.service.render();
    }

    public async login() {
        if (!this.loginId || !this.loginPw) {
            this.loginError = '아이디와 비밀번호를 입력하세요.';
            await this.service.render();
            return;
        }
        const { code, data } = await wiz.call("login", { id: this.loginId, password: this.loginPw });
        if (code === 200) {
            this.showLoginModal = false;
            this.isLoggedIn = true;
            this.userName = data.name || this.loginId;
            this.userRole = data.role || 'user';
            this.loginError = '';
        } else {
            this.loginError = data?.message || '로그인에 실패했습니다.';
        }
        await this.service.render();
    }

    public async logout() {
        await wiz.call("logout");
        this.isLoggedIn = false;
        this.userName = '';
        this.userRole = '';
        await this.service.render();
    }
}

export default PageHomeComponent;